<template>
  <div class="notification-buttons-group">
    <c-switch size="lg" type="icon" variant="primary" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" :checked="checked" :title="checked ? 'Wstrzymaj' : 'Uruchom'" @change="toggle"/>
    <b-button size="sm" variant="danger" title="Usuń" @click="remove()"><i class="fa fa-close"></i></b-button>
  </div>
</template>
<script>

import cSwitch from '../../Switch'

export default {
  props: ['checked'],
  components: {
    cSwitch
  },
  data () {
    return {
    }
  },
  name: 'c-notification-buttons',
  methods: {
    pause () {
      this.$emit('paused')
    },
    activate () {
      this.$emit('activated')
    },
    toggle (checked) {
      if (checked) {
        return this.activate()
      }
      return this.pause()
    },
    remove () {
      this.$emit('removed')
    }
  }
}
</script>
